import * as yup from 'yup'
import { TYPE_REQUIRED } from 'constants/errors'
import { birthDateSchema, zipCodeSchema } from 'helpers/schemaHelpers'
import homeSchema from 'schemas/homeSchema'
import { Car, Home, HousingType } from 'interfaces/property'
import { isHousingTypeWithZip } from 'helpers/formHelpers'
import { Schema } from 'yup'
import { ArraySchema } from 'yup'
import { YesNoValue } from 'components/features/pfm/PropertyForm/PropertyForm'

export const carSchema = yup.object().shape({
  make: yup.mixed().required(TYPE_REQUIRED),
  model: yup.mixed().required(TYPE_REQUIRED),
  year: yup.mixed().required(TYPE_REQUIRED),

  purchased_at: yup.mixed().required(TYPE_REQUIRED),
  estimated_value: yup.mixed().required(TYPE_REQUIRED),
})

export default yup.object().shape({
  birth_date: birthDateSchema,
  income: yup.mixed().required(TYPE_REQUIRED),
  car_owner: yup.string(),
  housing_type: yup.mixed().required(TYPE_REQUIRED),
  zip5: yup.mixed().when('housing_type', (housingType: HousingType, schema: Schema<HousingType | null>) => {
    return isHousingTypeWithZip(housingType) ? zipCodeSchema : schema
  }),
  cars: yup.array().when('car_owner', (carOwner: YesNoValue, schema: ArraySchema<Car>) => {
    return carOwner === 'yes' ? schema.of(carSchema as any) : schema
  }),
  homes: yup.array().when('housing_type', (housingType: HousingType, schema: ArraySchema<Home>) => {
    return housingType === 'ownership' ? schema.of(homeSchema as any) : schema
  }),
})
